module.exports = __webpack_public_path__ + "resources/video-2493964e32f77ec36cd6b9687558b5b0.svg";